import service from '@/store/services/workshop/parking-service';

const state = {
  list: {},
  parking: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, parking) => {
    state.parking = parking;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((parking) => { commit('SET_RESOURCE', parking); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((parking) => { commit('SET_RESOURCE', parking); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((parking) => { commit('SET_RESOURCE', parking); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  parking: state => state.parking,
  page: state => state.meta.page,
};
 
const parking = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default parking;
